import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentReference, QueryDocumentSnapshot, QuerySnapshot } from '@angular/fire/firestore';
import { Params, Router } from '@angular/router';
import { Page } from '../interfaces/page';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  filters: Params = {
    products: [],
    patterns: [],
    elements: [],
  };
  pages: Page[] = [];
  lastPageSnapshot?: QueryDocumentSnapshot<Page>;

  constructor(private router: Router, private firestore: AngularFirestore) { }

  getPages(): void {
    // consolidate active filters if any is selected
    let consolidatedFilters: DocumentReference[] = [];
    for (let colUid in this.filters) {
      if (this.filters[colUid].length > 0) {
        this.filters[colUid].forEach((docUid) => {
          const filterDocRef = this.firestore
            .collection(colUid)
            .doc(docUid).ref;
          consolidatedFilters.push(filterDocRef);
        });
      }
    }
    // set up the collection based on whether filters are active or not
    let collection: AngularFirestoreCollection<Page>;
    if (consolidatedFilters.length > 0) {
      collection = this.firestore
        .collection<Page>('pages', ref => ref
          .limit(16)
          .orderBy('product')
          .where('tags', 'array-contains-any', consolidatedFilters)
          .startAfter(this.lastPageSnapshot ? this.lastPageSnapshot : '')
        );
    } else {
      collection = this.firestore
        .collection<Page>('pages', ref => ref
          .limit(16)
          .orderBy('product')
          .startAfter(this.lastPageSnapshot ? this.lastPageSnapshot : '')
        );
    }
    // then get the collection docs and set it
    collection
      .get()
      .toPromise()
      .then(querySnapshot => {
        this.setPagesArray(querySnapshot);
        // reassign last page ref
        if (querySnapshot.size > 0) {
          this.lastPageSnapshot = querySnapshot.docs[querySnapshot.size - 1];
        }
      });
  }

  setPagesArray(querySnapshot: QuerySnapshot<Page>): void {
    querySnapshot.docs.forEach(
      (docSnapshot: QueryDocumentSnapshot<Page>) => {
        const page = docSnapshot.data();
        // hydrate product object
        page.product.get().then(res => {
          page.product = res.data();
          this.pages.push(page);
        });
      }
    );
  }

  // apply filter
  applyFilter(colUid: string, docUid: string): void {
    let filterObject = {};
    filterObject[colUid] = [];

    // copy current filter array
    const filterArray = filterObject[colUid];
    this.filters[colUid].forEach((filter) => {
      filterArray.push(filter);
    });

    // check if filter is already applied and add or remove from array
    const filterIndex = filterArray.indexOf(docUid);
    if (filterIndex < 0) {
      filterArray.push(docUid);
    } else {
      filterArray.splice(filterIndex, 1);
    }

    // then navigate using query parameters
    this.router.navigate(['/gallery'], {
      queryParams: filterObject,
      queryParamsHandling: 'merge',
    });
  }
}
